import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campVcNew: FaireAdCampaignEntity = {
  token: "camp_vc_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_verve_culture",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 1800,
  startedRunningAt: "2023-11-02",
  segmentMetrics: {
    numCustomersAcquired: 490,
    salesDollars: 311898,
    totalAdsSpendDollars: 42419,
    cpaDollars: 76.63,
    bestEstimateSalesDollars: 314757,
    bestEstimateRoas: 7.42,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
